/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React, { useState, useEffect, useCallback } from 'react';
import './VideoGallery.css';

const VIDEOS = [
  { id: 'C4e5yA7-boc', title: 'Featured Session', artist: 'Mastered Trax', year: '2024' },
  { id: 'KqmfcS2_hGc', title: 'Estreno Oficial', artist: 'Mastered Trax', year: '2024' },
  { id: 'VaFgbxhwXtY', title: 'Live Performance', artist: 'Mastered Trax', year: '2023' },
  { id: 'PvkjqrTEd1A', title: 'Studio Session', artist: 'Mastered Trax', year: '2023' },
  { id: 'IgHZK93xwFU', title: 'Music Video', artist: 'Mastered Trax', year: '2023' },
  { id: 'Sxq-TYHiS5c', title: 'Don Aero', artist: 'Don Aero', year: '2022' },
  { id: 'adj1jpQ4aMk', title: 'Melódico', artist: 'Melódico', year: '2022' },
  { id: 'ex4R-TeekxU', title: 'SWAT', artist: 'SWAT', year: '2022' },
  { id: 'qpgL5VPDc0g', title: 'Dub-G', artist: 'Dub-G', year: '2021' },
];

function thumb(id) {
  return `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;
}

function VideoGallery() {
  const [active, setActive] = useState(null);

  const close = useCallback(() => setActive(null), []);

  useEffect(() => {
    if (!active) return;
    const onKey = (e) => { if (e.key === 'Escape') close(); };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [active, close]);

  return (
    <section className="mt-videos">
      <div className="mt-container mt-videos__topline">
        <span className="mt-kicker">{VIDEOS.length} Videos · Archive</span>
        <p>
          Una selección curada — sesiones de estudio, estrenos oficiales y
          presentaciones en vivo. Haz clic para ver sin salir de la página.
        </p>
      </div>

      <ul className="mt-videos__grid mt-container">
        {VIDEOS.map((v, i) => (
          <li
            key={v.id}
            className={`mt-videos__item ${i % 5 === 0 ? 'mt-videos__item--wide' : ''}`}
          >
            <button
              type="button"
              className="mt-videos__card"
              onClick={() => setActive(v)}
              aria-label={`Play ${v.title}`}
            >
              <img
                src={thumb(v.id)}
                alt={v.title}
                loading="lazy"
                onError={(e) => { e.currentTarget.src = `https://i.ytimg.com/vi/${v.id}/hqdefault.jpg`; }}
              />
              <span className="mt-videos__overlay" aria-hidden="true" />
              <span className="mt-videos__num">N° {String(i + 1).padStart(2, '0')}</span>
              <span className="mt-videos__play">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M8 5.5v13l11-6.5-11-6.5Z"/>
                </svg>
                <span>Play</span>
              </span>
              <span className="mt-videos__caption">
                <span className="mt-videos__title">{v.title}</span>
                <span className="mt-videos__meta">{v.artist} · {v.year}</span>
              </span>
            </button>
          </li>
        ))}
      </ul>

      {active && (
        <div className="mt-videos__lightbox" role="dialog" aria-modal="true" onClick={close}>
          <button className="mt-videos__close" onClick={close} aria-label="Close video">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M6 6l12 12M18 6 6 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </button>
          <div className="mt-videos__lightboxInner" onClick={(e) => e.stopPropagation()}>
            <iframe
              title={active.title}
              src={`https://www.youtube.com/embed/${active.id}?autoplay=1&rel=0`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <div className="mt-videos__lightboxCaption">
              <span className="mt-kicker">{active.artist}</span>
              <h3>{active.title}</h3>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default VideoGallery;
